module.exports = __webpack_public_path__ + "static/media/main.207a22a1.png";